export function DtoDataResLogin() {
    return {
        Password: '',
        UserName: '',
        UserFirstName: '',
        UserLastName: '',
        UserAge: 0
    }
};